var map = {
	"./ar.json": "af08",
	"./by.json": "7094",
	"./en.json": "edd4",
	"./fr.json": "f693",
	"./he.json": "ba8d",
	"./ko.json": "dd11",
	"./kz.json": "d809",
	"./ru.json": "7704",
	"./tr.json": "ffeb",
	"./ua.json": "94b0",
	"./uz.json": "7500"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";